var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"release-user"},[_c('RadioGroup',{staticStyle:{"margin-left":"16px"},attrs:{"type":"button"},model:{value:(_vm.status),callback:function ($$v) {_vm.status=$$v},expression:"status"}},[_c('Radio',{attrs:{"label":"0"}},[_vm._v("全部")]),_c('Radio',{attrs:{"label":"1"}},[_vm._v("洽谈中")]),_c('Radio',{attrs:{"label":"2"}},[_vm._v("已合作")]),_c('Radio',{attrs:{"label":"3"}},[_vm._v("未合作")])],1),_c('div',{staticStyle:{"padding":"0 20px","margin-top":"20px"}},[_c('Table',{attrs:{"columns":_vm.columns1,"data":_vm.data1},scopedSlots:_vm._u([{key:"comName",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.comName))]}},{key:"link",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.link))]}},{key:"tel",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.tel))]}},{key:"type",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_vm._v(_vm._s(row.type))]}},{key:"info",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('Tooltip',{attrs:{"transfer":true,"max-width":"200","content":row.info,"placement":"top"}},[_c('p',{staticClass:"release-user-p"},[_vm._v(_vm._s(row.info))])])]}},{key:"status",fn:function(ref){
var row = ref.row;
var index = ref.index;
return [_c('p',{staticStyle:{"color":"#1890ff"}},[_vm._v(_vm._s(row.status))])]}}])})],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }